import { render } from "./ChangeNameENView.vue?vue&type=template&id=5bb206c6"
import script from "./ChangeNameENView.vue?vue&type=script&lang=js"
export * from "./ChangeNameENView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__